module.exports = __webpack_public_path__ + "img/antwerp-logo-icon.8660a2f3.png";